/** @format */

import React from "react";
import { FaPersonWalkingWithCane } from "react-icons/fa6";
import { TfiUnlink } from "react-icons/tfi";
import { MdOutlineChat } from "react-icons/md";
import { CiSettings } from "react-icons/ci";

function PermissionSection3({ rolePermissionIds, onTogglePermission }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Notice Board */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          <FaPersonWalkingWithCane />
          <span>Notice Board</span>
        </h2>

        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="noticeBoardOverview"
              checked={rolePermissionIds.includes("7")}
              onChange={() => onTogglePermission("7")}
            />
            <span className="ml-2 text-gray-700">Notice Board Overview</span>
          </label>
        </div>

        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="addNotice"
              checked={rolePermissionIds.includes("1020")}
              onChange={() => onTogglePermission("1020")}
            />
            <span className="ml-2 text-gray-700">Add Notice</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="editNotice"
                checked={rolePermissionIds.includes("10011")}
                onChange={() => onTogglePermission("10011")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="deleteNotice"
                checked={rolePermissionIds.includes("10012")}
                onChange={() => onTogglePermission("10012")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
      </div>

      {/* Master Data */}

      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          {" "}
          <TfiUnlink />
          <span>Master Data</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="masterDataOverview"
              checked={rolePermissionIds.includes("8")}
              onChange={() => onTogglePermission("8")}
            />
            <span className="ml-2 text-gray-700">Master Data Overview</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="bankLoanReimbursement"
              checked={rolePermissionIds.includes("170")}
              onChange={() => onTogglePermission("170")}
            />
            <span className="ml-2 text-gray-700">Bank Loan Reimbursement</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="bankBranchesSetup"
              checked={rolePermissionIds.includes("171")}
              onChange={() => onTogglePermission("171")}
            />
            <span className="ml-2 text-gray-700">Bank Branches Setup</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="bankSetup"
                checked={rolePermissionIds.includes("1021")}
                onChange={() => onTogglePermission("1021")}
              />
              <span className="ml-2 text-gray-700">Bank Setup</span>
            </label>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="addBankSetup"
                  checked={rolePermissionIds.includes("10013")}
                  onChange={() => onTogglePermission("10013")}
                />
                <span className="ml-2 text-gray-700">Add</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="bankSetupEdit"
                  checked={rolePermissionIds.includes("10014")}
                  onChange={() => onTogglePermission("10014")}
                />
                <span className="ml-2 text-gray-700">Edit</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="bankSetupDelete"
                  checked={rolePermissionIds.includes("10015")}
                  onChange={() => onTogglePermission("10015")}
                />
                <span className="ml-2 text-gray-700">Delete</span>
              </label>
            </div>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="branchSetup"
                checked={rolePermissionIds.includes("1022")}
                onChange={() => onTogglePermission("1022")}
              />
              <span className="ml-2 text-gray-700">Branch Setup</span>
            </label>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="addBranchSetup"
                  checked={rolePermissionIds.includes("10016")}
                  onChange={() => onTogglePermission("10016")}
                />
                <span className="ml-2 text-gray-700">Add</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="branchSetupEdit"
                  checked={rolePermissionIds.includes("10017")}
                  onChange={() => onTogglePermission("10017")}
                />
                <span className="ml-2 text-gray-700">Edit</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="branchSetupDelete"
                  checked={rolePermissionIds.includes("10018")}
                  onChange={() => onTogglePermission("10018")}
                />
                <span className="ml-2 text-gray-700">Delete</span>
              </label>
            </div>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="workingOfficeSetup"
              checked={rolePermissionIds.includes("172")}
              onChange={() => onTogglePermission("172 ")}
            />
            <span className="ml-2 text-gray-700">Working Office Setup</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="addWorkingOfficeSetup"
                checked={rolePermissionIds.includes("10020")}
                onChange={() => onTogglePermission("10020")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="workingOfficeSetupEdit"
                checked={rolePermissionIds.includes("10021")}
                onChange={() => onTogglePermission("10021")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="workingOfficeSetupDelete"
                checked={rolePermissionIds.includes("10022")}
                onChange={() => onTogglePermission("10022")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="departments"
              checked={rolePermissionIds.includes("173")}
              onChange={() => onTogglePermission("173")}
            />
            <span className="ml-2 text-gray-700">Departments</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="adddepartments"
                checked={rolePermissionIds.includes("10023")}
                onChange={() => onTogglePermission("10023")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="departmentsEdit"
                checked={rolePermissionIds.includes("10024")}
                onChange={() => onTogglePermission("10024")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="departmentsDelete"
                checked={rolePermissionIds.includes("10025")}
                onChange={() => onTogglePermission("10025")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="Designations"
              checked={rolePermissionIds.includes("174")}
              onChange={() => onTogglePermission("174")}
            />
            <span className="ml-2 text-gray-700">Designations</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="addDesignations"
                checked={rolePermissionIds.includes("10026")}
                onChange={() => onTogglePermission("10026")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="DesignationsEdit"
                checked={rolePermissionIds.includes("10027")}
                onChange={() => onTogglePermission("10027")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="DesignationsDelete"
                checked={rolePermissionIds.includes("10028")}
                onChange={() => onTogglePermission("10028")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="employeeGrade"
              checked={rolePermissionIds.includes("175")}
              onChange={() => onTogglePermission("175")}
            />
            <span className="ml-2 text-gray-700">Employee Grade</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="addEmployeeGrade"
                checked={rolePermissionIds.includes("10029")}
                onChange={() => onTogglePermission("10029")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="employeeGradeEdit"
                checked={rolePermissionIds.includes("10030")}
                onChange={() => onTogglePermission("10030")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="employeeGradeDelete"
                checked={rolePermissionIds.includes("10031")}
                onChange={() => onTogglePermission("10031")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="reimbursement"
              checked={rolePermissionIds.includes("176")}
              onChange={() => onTogglePermission("176")}
            />
            <span className="ml-2 text-gray-700">Reimbursement</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="addReimbursement"
                checked={rolePermissionIds.includes("10032")}
                onChange={() => onTogglePermission("10032")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="reimbursementEdit"
                checked={rolePermissionIds.includes("10033")}
                onChange={() => onTogglePermission("10033")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
        </div>
      </div>
      {/* Settings */}
      <div className="bg-white rounded-lg shadow-md p-4">
        <h2 className="text-lg font-semibold mb-2 flex items-center space-x-2">
          {" "}
          <MdOutlineChat />
          <span>Settings</span>
        </h2>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="settingsOverview"
              checked={rolePermissionIds.includes("9")}
              onChange={() => onTogglePermission("9")}
            />
            <span className="ml-2 text-gray-700">Settings Overview</span>
          </label>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="userManagement"
              checked={rolePermissionIds.includes("180")}
              onChange={() => onTogglePermission("180")}
            />
            <span className="ml-2 text-gray-700">User Management</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="userManagementAdd"
                checked={rolePermissionIds.includes("10034")}
                onChange={() => onTogglePermission("10034")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="userManagementEdit"
                checked={rolePermissionIds.includes("10035")}
                onChange={() => onTogglePermission("10035")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="roleManagement"
              checked={rolePermissionIds.includes("181")}
              onChange={() => onTogglePermission("181")}
            />
            <span className="ml-2 text-gray-700">Role Management</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="roleCreation"
                checked={rolePermissionIds.includes("1023")}
                onChange={() => onTogglePermission("1023")}
              />
              <span className="ml-2 text-gray-700">Role Creation</span>
            </label>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="roleCreationAdd"
                  checked={rolePermissionIds.includes("10036")}
                  onChange={() => onTogglePermission("10036")}
                />
                <span className="ml-2 text-gray-700">Add</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="roleCreationEdit"
                  checked={rolePermissionIds.includes("10037")}
                  onChange={() => onTogglePermission("10037")}
                />
                <span className="ml-2 text-gray-700">Edit</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="roleCreationDelete"
                  checked={rolePermissionIds.includes("10038")}
                  onChange={() => onTogglePermission("10038")}
                />
                <span className="ml-2 text-gray-700">Delete</span>
              </label>
            </div>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="roleManagement"
                checked={rolePermissionIds.includes("1024")}
                onChange={() => onTogglePermission("1024")}
              />
              <span className="ml-2 text-gray-700">Role Management</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="supervisor"
              checked={rolePermissionIds.includes("182")}
              onChange={() => onTogglePermission("182")}
            />
            <span className="ml-2 text-gray-700">Supervisor</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="supervisorAdd"
                checked={rolePermissionIds.includes("10039")}
                onChange={() => onTogglePermission("10039")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="supervisorEdit"
                checked={rolePermissionIds.includes("10040")}
                onChange={() => onTogglePermission("10040")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="addBranchType"
              checked={rolePermissionIds.includes("183")}
              onChange={() => onTogglePermission("183")}
            />
            <span className="ml-2 text-gray-700">Add Branch Type</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="branchTypeAdd"
                checked={rolePermissionIds.includes("10041")}
                onChange={() => onTogglePermission("10041")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="branchTypeEdit"
                checked={rolePermissionIds.includes("10042")}
                onChange={() => onTogglePermission("10042")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="branchTypeDelete"
                checked={rolePermissionIds.includes("10043")}
                onChange={() => onTogglePermission("10043")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="addEmployeeType"
              checked={rolePermissionIds.includes("184")}
              onChange={() => onTogglePermission("184")}
            />
            <span className="ml-2 text-gray-700">Add Employee Type</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="employeeTypeAdd"
                checked={rolePermissionIds.includes("10044")}
                onChange={() => onTogglePermission("10044")}
              />
              <span className="ml-2 text-gray-700">Add</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="employeeTypeEdit"
                checked={rolePermissionIds.includes("10045")}
                onChange={() => onTogglePermission("10045")}
              />
              <span className="ml-2 text-gray-700">Edit</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="employeeTypeDelete"
                checked={rolePermissionIds.includes("10046")}
                onChange={() => onTogglePermission("10046")}
              />
              <span className="ml-2 text-gray-700">Delete</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="salaryComponent"
              checked={rolePermissionIds.includes("185")}
              onChange={() => onTogglePermission("185")}
            />
            <span className="ml-2 text-gray-700">Salary Component</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="changeCurrency"
                checked={rolePermissionIds.includes("10047")}
                onChange={() => onTogglePermission("10047")}
              />
              <span className="ml-2 text-gray-700">Change Currency</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="addSalaryComponent"
                checked={rolePermissionIds.includes("10048")}
                onChange={() => onTogglePermission("10048")}
              />
              <span className="ml-2 text-gray-700">Add Salary Component</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="leaveCategory"
              checked={rolePermissionIds.includes("186")}
              onChange={() => onTogglePermission("186")}
            />
            <span className="ml-2 text-gray-700">Leave Category</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="createLeaveCategory"
                checked={rolePermissionIds.includes("1025")}
                onChange={() => onTogglePermission("1025")}
              />
              <span className="ml-2 text-gray-700">Create Leave Category</span>
            </label>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="leaveCategoryAdd"
                  checked={rolePermissionIds.includes("10049")}
                  onChange={() => onTogglePermission("10049")}
                />
                <span className="ml-2 text-gray-700">Save</span>
              </label>
            </div>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="leaveCategories"
                checked={rolePermissionIds.includes("1026")}
                onChange={() => onTogglePermission("1026")}
              />
              <span className="ml-2 text-gray-700">Leave Categories</span>
            </label>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="viewCategories"
                  checked={rolePermissionIds.includes("10050")}
                  onChange={() => onTogglePermission("10050")}
                />
                <span className="ml-2 text-gray-700">View Categories</span>
              </label>
            </div>
            <div className="ml-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-radio h-4 w-4 text-gray-600"
                  name="editCategories"
                  checked={rolePermissionIds.includes("10051")}
                  onChange={() => onTogglePermission("10051")}
                />
                <span className="ml-2 text-gray-700">Edit Categories</span>
              </label>
            </div>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="assignRoster"
              checked={rolePermissionIds.includes("187")}
              onChange={() => onTogglePermission("187")}
            />
            <span className="ml-2 text-gray-700">Assign Roster</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="assignRoster"
                checked={rolePermissionIds.includes("10052")}
                onChange={() => onTogglePermission("10052")}
              />
              <span className="ml-2 text-gray-700">Add Roster</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="editRoster"
                checked={rolePermissionIds.includes("10053")}
                onChange={() => onTogglePermission("10053")}
              />
              <span className="ml-2 text-gray-700">Edit Roster</span>
            </label>
          </div>
        </div>
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              className="form-checkbox h-5 w-5 text-gray-600"
              name="createLoan"
              checked={rolePermissionIds.includes("188")}
              onChange={() => onTogglePermission("188")}
            />
            <span className="ml-2 text-gray-700">Create Loan</span>
          </label>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="assignLoan"
                checked={rolePermissionIds.includes("10054")}
                onChange={() => onTogglePermission("10054")}
              />
              <span className="ml-2 text-gray-700">Add Loan</span>
            </label>
          </div>
          <div className="ml-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-radio h-4 w-4 text-gray-600"
                name="editLoan"
                checked={rolePermissionIds.includes("10055")}
                onChange={() => onTogglePermission("10055")}
              />
              <span className="ml-2 text-gray-700">Edit Loan</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PermissionSection3;
